import { getBackendConfig } from './config/backend';

// Configuration for different environments
interface EnvironmentConfig {
  apiBaseUrl: string;
  storageBucket: string;
  environment: 'development' | 'production' | 'test';
  debug: boolean;
}

interface Config {
  development: EnvironmentConfig;
  production: EnvironmentConfig;
  test: EnvironmentConfig;
}

const getConfig = (): Config => {
  const environment = process.env.NODE_ENV || 'development';
  const backendConfig = getBackendConfig();
  
  // Debug logging to help identify configuration issues
  console.log('🔧 Config Debug Info:', {
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
    environment: environment,
    backendEnvironment: backendConfig.environment
  });
  
  // Use backend configuration for API URL (backendConfig already checks NEXT_PUBLIC_API_BASE)
  const apiUrl = backendConfig.apiBaseUrl;
  
  console.log('🔧 Using API URL:', apiUrl, 'from backend config:', backendConfig.apiBaseUrl);

  return {
    // Development configuration
    development: {
      apiBaseUrl: apiUrl,
      storageBucket: process.env.REACT_APP_STORAGE_BUCKET || 'local',
      environment: 'development' as const,
      debug: true,
    },
    
    // Production configuration
    production: {
      apiBaseUrl: apiUrl,
      storageBucket: process.env.REACT_APP_STORAGE_BUCKET || 'your-gcs-bucket-name',
      environment: 'production' as const,
      debug: false,
    },

    // Test configuration
    test: {
      apiBaseUrl: apiUrl,
      storageBucket: process.env.REACT_APP_STORAGE_BUCKET || 'test-local',
      environment: 'test' as const,
      debug: true,
    },
  };
};

const config = getConfig();

// Export the appropriate configuration based on NODE_ENV
const currentConfig = process.env.NODE_ENV === 'production' 
  ? config.production 
  : process.env.NODE_ENV === 'test'
  ? config.test
  : config.development;

// Debug logging for final configuration
console.log('🔧 Final Config:', {
  environment: currentConfig.environment,
  apiBaseUrl: currentConfig.apiBaseUrl,
  debug: currentConfig.debug
});

export { config };
export default currentConfig;
